import { Dispatch, JSXElementConstructor, MutableRefObject, ReactElement, SetStateAction, useEffect, useRef, useState } from "react"
import { useOutsideAlerter } from "../../../../../../hooks/outsideClickHook";
import { ICota } from ".";

function DeleteButton({ coords, deleteCota }: { coords: { x: number, y: number }, deleteCota: () => void }) {

    const [hovered, setHovered] = useState(false);
    return (
        <g className="cursor-pointer" x={coords.x + 20} y={coords.y - 30} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={(e) => {
            e.stopPropagation()
            deleteCota();
            console.log("Deleting cota!!");
        }}>
            <rect x={coords.x + 20} y={coords.y - 40} width={60} height={20} fill="white" stroke={hovered ? "red" : "black"} rx={5} ry={5} />
            <text x={coords.x + 50} y={coords.y - 25} textAnchor="middle" fill={hovered ? "red" : "black"}>Apagar</text>
        </g>
    )
}


function EditButton({ coords, setIsEditable }: { coords: { x: number, y: number }, setIsEditable: () => void }) {

    const [hovered, setHovered] = useState(false);

    return (
        <g className="cursor-pointer" x={coords.x + 20} y={coords.y - 60} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={(e) => {
            e.stopPropagation()
            setIsEditable();

        }}>
            <rect x={coords.x + 20} y={coords.y - 70} width={60} height={20} fill="white" stroke={hovered ? "red" : "black"} rx={5} ry={5} />
            <text x={coords.x + 50} y={coords.y - 55} textAnchor="middle" fill={hovered ? "red" : "black"}>Editar</text>
        </g>
    )
}


export function Cota({ cota, updateCota, updateCotaMutation, deleteCota, svgRef }: { cota: ICota, deleteCota: (n: number)  => void, updateCotaMutation: any, updateCota: (n: number, value: Partial<ICota>)=> void, svgRef: any }) {


    const [isEditable, setIsEditable] = useState(false);
    const [locked, setLocked] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [rightClicked, setRightClicked] = useState(false);

    const ref = useRef<any>(null)

    // useOutsideAlerter(ref, (e : any) => {
    //     e.stopPropagation();
    //     setIsEditable(false);
    // })


    function onMouseDown(e: any) {
        e.preventDefault();
        e.stopPropagation();
        if(isEditable) {
            setIsEditable(false);
            return;
        }
        locked ? handleRelease() : setLocked(true);
    }

    function handleRelease() {
        updateCotaMutation.mutate({cota})
        setLocked(false);
    }


    function onRightClick(e: any) {
        e.preventDefault();
        rightClicked ? setRightClicked(false) : setRightClicked(true);
    }

    const handleWindowMouseMove = (e: any) => {
        if (locked) {
            const svgElement = svgRef.current;
            if (!svgElement) return;
            const svgRect = svgElement.getBoundingClientRect();
            const x = e.clientX - svgRect.left;
            const y = e.clientY - svgRect.top;
            updateCota(cota.internalId, { x, y});
        }
    }


    return (
        <>
            <circle
                 cx={cota.initialX}
                 cy={cota.initialY}
                 r="5"
                 fill="orange"
            />
            <line x1={cota.initialX} y1={cota.initialY} x2={cota.x} y2={cota.y} stroke="orange" stroke-width="2" />

            {
                locked ?
                    <circle
                        // onMouseUp={onMouseUp}
                        onMouseMove={handleWindowMouseMove}
                        cx={cota.x}
                        cy={cota.y}
                        r="100"
                        fill="red"
                        opacity={0.1}
                        z={900}
                    /> : null}

            <circle
                ref={ref}
                onClick={onMouseDown}
                className="cursor-pointer"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onContextMenu={onRightClick}
                cx={cota.x}
                cy={cota.y}
                r="25"
                fill={hovered && !locked ? "cyan" : "white"}
                stroke={locked ? 'cyan' : 'black'}
                z={1000}
            />
            {isEditable ?
                <foreignObject
                    x={cota.x - 50}
                    y={cota.y - 13} width="100" height="100">
                    <div className="flex flex-col items-center justify-center">
                        <input
                            value={cota.number}
                            onChange={(e: any) => {
                                console.log("Changing number: ", e.tagret.value);
                                updateCota(cota.internalId, {number: parseInt(e.target.value) | 0})
                            }}
                            type="text"
                            className="w-10 h-20 py-2 text-[2em] font-bold border-none flex"
                        // placeholder="Type here"
                        />
                        <button
                            className="mt-5 bg-white border border-solid border-black rounded-md p-1"
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsEditable(false)
                            }}>Confirmar</button>
                    </div>
                </foreignObject>

                : <text
                    className="cursor-pointer"
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    onContextMenu={onRightClick}
                    onClick={onMouseDown}
                    fontSize={30}
                    fontWeight={'bold'}
                    textAnchor="middle"
                    x={cota.x}
                    y={cota.y + 10}
                >{cota.number}</text>}
            {
                rightClicked ?
                    <>
                        <EditButton setIsEditable={() => {
                            setIsEditable(true)
                        }} coords={cota} />
                        <DeleteButton deleteCota={()=> deleteCota(cota.internalId)} coords={cota} />
                    </>
                    : null
            }
        </>
    )


}